import { SupportedCountry } from "../constants/countries";
import {
	CCOGermanyCPSubForm,
	CCOGermanyCPSubFormValues,
} from "./germany/CCOGermanyCPSubForm";
import {
	CCOFranceCPSubForm,
	CCOFranceCPSubFormValues,
} from "./france/CCOFranceCPSubForm";

export interface GenerateCurtailmentObjectsProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (
		values: CCOGermanyCPSubFormValues | CCOFranceCPSubFormValues
	) => void;
	country: SupportedCountry;
	existingValues?: CCOGermanyCPSubFormValues | CCOFranceCPSubFormValues;
	onSkip?: () => void;
}

export const GenerateCurtailmentObjects = ({
	isOpen,
	onClose,
	onSubmit,
	country,
	existingValues,
	onSkip,
}: GenerateCurtailmentObjectsProps) => {
	if (country === SupportedCountry.GERMANY) {
		return (
			<CCOGermanyCPSubForm
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={onSubmit}
				existingValues={existingValues as CCOGermanyCPSubFormValues}
				onSkip={onSkip}
			/>
		);
	} else if (country === SupportedCountry.FRANCE) {
		return (
			<CCOFranceCPSubForm
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={onSubmit}
				existingValues={existingValues as CCOFranceCPSubFormValues}
				onSkip={onSkip}
			/>
		);
	}
	return null;
};
